/**
 * Mapa estatico de World IDs do Cabal EP39 -> nome do mundo (PT-BR).
 *
 * Usado pra embelezar notificacoes de loot (substituir "World 24" por nome).
 * Nao precisa cobrir 100% — qualquer ID nao mapeado cai no fallback "Mundo N".
 *
 * Fonte: nomes oficiais da localizacao BR do Cabal Online. IDs extraidos
 * do server EP33 e do client EP39.
 */

const WORLDS: Record<number, string> = {
  1: 'Tundra Infame',
  2: 'Deserto Lamentação',
  3: 'Floresta do Desespero',
  4: 'Porto Lux',
  5: 'Forte Ruína',
  6: 'Região dos Lagos',
  7: 'Santuário Profano',
  8: 'Elo Perdido',
  9: 'Floresta Mutante',
  10: 'Pontus Ferrum',
  11: 'Portal Infernus',
  12: 'Vestígio Arcano',
  13: 'Torre dos Mortos 1SS Enfraquecida',
  14: 'Estação Ruína',
  15: 'Tierra Gloriosa',
  16: 'AUTRA',
  17: 'Torre dos Mortos 2SS Enfraquecida',
  18: 'OTAM',
  19: 'Prisão',
  20: 'Arena do Caos',
  21: 'Tierra del Bruto',
  22: 'Senillinea',
  23: 'Templo Esquecido 1SS',
  24: 'Cidadela Vulcânica',
  25: 'Vulcão do Exílio',
  26: 'Lago do Crepúsculo (antiga)',
  27: 'Calabouço Mundo 3',
  28: 'Calabouço Mundo 2',
  29: 'Calabouço Mundo 1',
  30: 'Central de Teletransporte',
  31: 'LBS',
  32: 'Templo Esquecido 2SS',
  33: 'Ilha Proibida',
  34: 'Altar de Siena 1SS',
  35: 'Altar de Siena 2SS',
  36: 'Caverna do Pânico',
  37: 'Caverna do Pânico',
  38: 'Caverna do Pânico',
  39: 'Enfraquecido Lago do Crepúsculo',
  40: 'Enfraquecida Estação Ruina',
  41: 'Enfraquecida Torre dos Mortos 1SS',
  42: 'Locomotiva Fantasma',
  43: 'Locomotiva Fantasma',
  44: 'Locomotiva Fantasma',
  45: 'Castelo das Ilusões',
  46: 'Catacumba Gélida',
  47: 'Catacumba Gélida',
  48: 'Catacumba Gélida',
  49: 'Salão Radiante do Castelo das Ilusões Enfraquecido',
  50: 'Arena do Caos Nv.1',
  51: 'Arena do Caos Nv.2',
  52: 'Arena do Caos Nv.3',
  53: 'Arena do Caos Nv.4',
  54: 'Arena do Caos Nv.5',
  55: 'Arena do Caos Nv.6',
  56: 'Caverna do Pânico (Premium)',
  57: 'Locomotiva Louca (Premium)',
  58: 'Catacumba Gélida (Premium)',
  59: 'Arena da Defesa',
  60: 'Morada das Chamas Infernais',
  61: 'Morada das Chamas Infernais',
  62: 'Morada das Chamas Infernais',
  63: 'Morada das Chamas Infernais (Premium)',
  64: 'Tundra Infame',
  65: 'Labirinto Desconhecido',
  66: 'Forte Ruína',
  67: 'Deserto da Lamentação',
  68: 'Posto Avançado de Maquinas',
  69: 'Central de Teletransporte',
  70: 'Floresta do Desespero',
  71: 'Porto Lux',
  72: 'Ruína Esquecida',
  73: 'Região dos Lagos',
  74: 'Vale Tempestuoso',
  75: 'Vale Tempestuoso',
  76: 'Vale Tempestuoso',
  77: 'Caos Infinito',
  78: 'Missão de Batalha 1',
  79: 'Missão de Batalha 2',
  80: 'Missão de Batalha 3',
  81: 'Missão de Batalha 4',
  82: 'Missão de Batalha 5',
  83: 'Missão de Batalha 6',
  84: 'Missão de Batalha 7',
  85: 'Missão de Batalha 8',
  86: 'Missão de Batalha 9',
  87: 'Missão de Batalha 10',
  88: 'Torre dos Mortos 3SS',
  89: 'Templo Esquecido 2SS (Desperto)',
  90: 'Ilha Proibida (Desperta)',
  91: 'Floresta da Nostalgia 1',
  92: 'Floresta da Nostalgia 2',
  93: 'Floresta da Nostalgia 3',
  94: 'Floresta da Nostalgia 4',
  95: 'Floresta da Nostalgia 5',
  96: 'Floresta da Nostalgia 6',
  97: 'Floresta da Nostalgia 7',
  98: 'Floresta da Nostalgia 8',
  99: 'Floresta da Nostalgia 9',
  100: 'Floresta da Nostalgia 10',
  101: 'Área Eterno',
  102: 'Morada das Chamas Infernais (Desperto)',
  103: 'Caverna do Pânico (Desperto)',
  104: 'Locomotiva Louca (Desperto)',
  105: 'Catacumba Gélida (Desperto)',
  106: 'Vale Tempestuoso (Desperto)',
  107: 'Cidade Abandonada',
  108: 'Calabouço 4',
  109: 'Espada Brilhante_Tempesta Rosa',
  110: 'Memória Chrysos',
  111: 'Batalha PvP 1',
  112: 'Batalha PvP 2',
  113: 'Batalha PvP 3',
  114: 'Batalha PvP 4',
  115: 'Batalha PvP 5',
  116: 'Batalha PvP 6',
  117: 'Batalha PvP 7',
  118: 'Batalha PvP 8',
  119: 'Batalha PvP 9',
  120: 'Batalha PvP 10',
  121: 'Torre Dos Mortos 3SS',
  122: 'Arena Legendária',
  123: 'Torre dos Mortos 3ss (Parte 2)',
  124: 'Castelo das Ilusões(Apócrifos)',
  125: 'Salão Radiante do Castelo das Ilusões(Apócrifos)',
  126: 'Crista Ilusória',
  127: 'Templo Esquecido 3SS',
  128: 'Arena de Acheron',
  129: 'Torre Diabólica',
  130: 'Torre Diabólica (Parte2)',
  131: 'Torre Diabólica',
  132: 'Ilha da Miragem',
  133: 'Arena do Caos Nv.7',
  134: 'Entrada do Desafio',
  135: 'Dimensão das Chamas',
  136: 'Solo Flamejante',
  137: 'Tumba Ancestral',
  138: 'O Labirinto',
  139: 'Moinho Sagrado',
  140: 'Abertura da Dimensão',
  141: 'Abertura da Dimensão',
  142: 'Abertura da Dimensão',
  143: 'Abertura da Dimensão',
  144: 'Abertura da Dimensão',
  145: 'Abertura da Dimensão',
  146: 'Abertura da Dimensão',
  147: 'Abertura da Dimensão',
  148: 'Desfiladeiro Congelado',
  149: 'Keldrasil Sagrado',
  150: 'Torre dos Mortos 1SS',
  151: 'Torre dos Mortos 2SS',
  152: 'Ilha da Miragem (Desperta)',
  153: 'Fenda na Dimensão',
  154: 'Terminus Machina',
  155: 'Jardim Decadente',
  156: 'Lago do Crepúsculo',
  157: 'Laboratório Automata',
  158: 'Espada Brilhante_Tempesta Rosa',
  159: 'Ingens Proelium',
  160: 'Provação Infinita',
  161: 'Altar Sagrado',
  162: 'Palestra Inferna',
  163: 'Celestia',
  164: 'Salão Radiante do Castelo das Ilusões',
  165: 'Purificador na Floresta',
  166: 'Ingresso para o Legado de Madarat Lv.1',
  167: 'Ingresso para o Legado de Madarat Lv.2',
  168: 'Legado da entrada Madarat',
  169: 'Legado da entrada Madarat',
  170: 'Legado da entrada Madarat',
  171: 'Legado da entrada Madarat',
  172: 'Torre dos Mortos 4ss',
  173: 'Holia Exedium',
};

export function worldName(id: number | string | undefined | null): string {
  if (id == null) return 'mundo desconhecido';
  const n = typeof id === 'string' ? parseInt(id, 10) : id;
  if (!Number.isFinite(n) || n <= 0) return 'mundo desconhecido';
  return WORLDS[n] || `Mundo ${n}`;
}
